var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-form', {
    ref: "form",
    attrs: {
      "errors": _vm.serverValidations,
      "validate": _vm.validateForm,
      "readonly": _vm.isRegistering
    },
    on: {
      "submit": _vm.handleSubmit
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(api) {
        return [_c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "field": "activityType",
            "select": "",
            "items": _vm.activityTypes,
            "label": "Вид деятельности"
          },
          on: {
            "input": _vm.changeActivityType
          }
        }), _vm._v(" "), (_vm.activityType == 1) ? _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "field": "orgType",
            "select": "",
            "items": _vm.orgTypes,
            "label": "Форма собственности"
          }
        }) : _vm._e(), _vm._v(" "), (_vm.activityType == 1) ? _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "field": "companyName",
            "label": "Название компании"
          }
        }) : _vm._e(), _vm._v(" "), _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "field": "fio",
            "label": "ФИО"
          }
        }), _vm._v(" "), _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "field": "email",
            "label": "Email",
            "type": "email"
          },
          on: {
            "input": _vm.handleInputEmail
          }
        }), _vm._v(" "), _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (1),
            expression: "1",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "field": "password",
            "label": "Пароль",
            "type": "password",
            "maxlength": "16",
            "caption": "Не менее 6 символов"
          }
        }), _vm._v(" "), _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "field": "phoneNumber",
            "mask": "phone",
            "label": "Номер телефона"
          }
        }), _vm._v(" "), _c('v-form-checkbox', {
          attrs: {
            "field": "agreementAccepted",
            "data": "true",
            "readonly": _vm.isRegistering
          },
          scopedSlots: _vm._u([{
            key: "label",
            fn: function(label) {
              return [_c('v-text', {
                attrs: {
                  "type": "caption"
                }
              }, [_vm._v("\n                        Нажимая на кнопку «Зарегистрировать», вы даёте согласие на обработку\n                        "), _c('br'), _vm._v(" "), _c('v-link', {
                attrs: {
                  "to": "https://exbico.ru/page97982866.html",
                  "target": "_blank"
                }
              }, [_vm._v("\n                            персональных данных\n                        ")])], 1)]
            }
          }])
        }), _vm._v(" "), _c('div', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (4),
            expression: "4",
            modifiers: {
              "bottom": true
            }
          }, {
            name: "margin",
            rawName: "v-margin.top",
            value: (2),
            expression: "2",
            modifiers: {
              "top": true
            }
          }]
        }, [_c('v-spinner', {
          attrs: {
            "block": "",
            "active": _vm.isRegistering
          }
        }, [_c('v-button', {
          attrs: {
            "disabled": api.isInvalid || _vm.isDisabled,
            "type": "submit",
            "primary": "",
            "block": ""
          }
        }, [_vm._v("\n                        ЗАРЕГИСТРИРОВАТЬ\n                    ")])], 1), _vm._v(" "), (_vm.serverError) ? _c('div', {
          directives: [{
            name: "padding",
            rawName: "v-padding.top",
            value: (1),
            expression: "1",
            modifiers: {
              "top": true
            }
          }]
        }, [_c('v-text', {
          attrs: {
            "danger": ""
          }
        }, [_vm._v("\n                        " + _vm._s(_vm.serverError) + "\n                    ")])], 1) : _vm._e()], 1)]
      }
    }])
  }), _vm._v(" "), _c('v-modal', {
    attrs: {
      "active": _vm.isShowConfirm
    },
    on: {
      "close": _vm.handleModalClose
    }
  }, [_c('div', {
    directives: [{
      name: "padding",
      rawName: "v-padding",
      value: (2),
      expression: "2"
    }]
  }, [_c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (2),
      expression: "2",
      modifiers: {
        "bottom": true
      }
    }],
    attrs: {
      "type": "title"
    }
  }, [_vm._v(" Спасибо! Ваша заявка принята. ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (2),
      expression: "2",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_vm._v("\n                    Мы свяжемся с вами в ближайшее время.\n                ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "text-align",
      rawName: "v-text-align.right",
      modifiers: {
        "right": true
      }
    }, {
      name: "margin",
      rawName: "v-margin.top",
      value: (1),
      expression: "1",
      modifiers: {
        "top": true
      }
    }]
  }, [_c('v-button', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.handleModalClose
    }
  }, [_vm._v(" Закрыть ")])], 1)])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36fecd7a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/sign/Register/RegisterForm.vue
// module id = 850
// module chunks = 0